import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "sca-cookie-consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setShow(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (_err) {
      /* localStorage unavailable */
      setShow(true);
    }
  }, []);

  const accept = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (_err) {
      /* ignore */
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Política de cookies"
      data-testid="cookie-banner"
      className="fixed bottom-24 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-40 bg-sca-black text-white border border-sca-lineDark p-5 md:p-6"
    >
      <button
        type="button"
        onClick={() => accept("dismissed")}
        className="absolute top-3 right-3 text-white/60 hover:text-white"
        aria-label="Fechar banner de cookies"
        data-testid="cookie-banner-close"
      >
        <X className="w-4 h-4" />
      </button>
      <p className="sca-overline text-sca-red mb-3">[ Cookies ]</p>
      <p className="text-sm leading-relaxed text-white/85">
        Utilizamos cookies para melhorar sua navegação, analisar o uso do site e personalizar conteúdo.
        Ao continuar, você concorda com a nossa{" "}
        <Link to="/politica-de-cookies" className="underline underline-offset-4 hover:text-sca-red">
          Política de Cookies
        </Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          onClick={() => accept("accepted")}
          data-testid="cookie-accept-all"
          className="btn-sca-primary"
        >
          Aceitar
        </button>
        <button
          onClick={() => accept("essentials")}
          data-testid="cookie-accept-essentials"
          className="btn-sca px-5 py-3 border border-white/20 text-white/85 hover:border-white hover:text-white"
        >
          Apenas essenciais
        </button>
      </div>
    </div>
  );
}
